module.exports = __webpack_public_path__ + "static/media/captureall.051b536c.svg";